import React from 'react';
import { Outlet } from 'react-router-dom';
import Topbar from '../agent/layout/Topbar';
import TimeoutModal from '../shared/TimeoutModal';
import { NavModeProvider } from '../../hooks/useNavMode';

/**
 * AppChrome - Global layout wrapper that renders the persistent Topbar
 * This component ensures the Topbar is always present and never remounts
 * when navigating between Agent and Admin sections.
 * Topbar handles null user state internally.
 * Includes TimeoutModal for session management.
 * Wraps content in NavModeProvider to share navigation mode state.
 */
const AppChrome = () => {
  return (
    <NavModeProvider>
      <div className="flex flex-col h-screen overflow-hidden bg-gray-50">
        {/* Persistent Topbar - always rendered, never remounts */}
        <div className="flex-shrink-0">
          <Topbar />
        </div>
        {/* Content area - routes render here via Outlet; takes remaining height */}
        <div className="flex flex-1 min-h-0">
          <Outlet />
        </div>
      </div>
      {/* Timeout Modal - session management */}
      <TimeoutModal userRole="agent" />
    </NavModeProvider>
  );
};

export default AppChrome;

